import * as React from "react";
import { Pressable, StyleSheet, Text, type StyleProp, type ViewStyle } from "react-native";

export type ButtonVariant = "primary" | "secondary" | "danger";

export interface ButtonProps {
  label: string;
  onPress: () => void;
  variant?: ButtonVariant;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

const COLORS: Record<ButtonVariant, { bg: string; fg: string }> = {
  primary: { bg: "#247AC2", fg: "#ffffff" },
  secondary: { bg: "#EEF3F9", fg: "#27364D" },
  danger: { bg: "#dc2626", fg: "#ffffff" },
};

/** Shared cross-platform button (React Native + react-native-web). */
export function Button({
  label,
  onPress,
  variant = "primary",
  disabled = false,
  style,
  testID,
}: ButtonProps): React.JSX.Element {
  const colors = COLORS[variant];
  return (
    <Pressable
      accessibilityRole="button"
      testID={testID}
      disabled={disabled}
      onPress={onPress}
      style={({ pressed }) => [
        styles.base,
        { backgroundColor: colors.bg, opacity: disabled ? 0.5 : pressed ? 0.8 : 1 },
        style,
      ]}
    >
      <Text style={[styles.label, { color: colors.fg }]}>{label}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  base: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 10,
    minHeight: 44,
    alignItems: "center",
    justifyContent: "center",
  },
  label: {
    fontSize: 15,
    fontWeight: "600",
  },
});
